export default "__VITE_ASSET__Byy82Oky__"